import { CustomerPermissions } from '@engineering11/customer-web'
import { PaymentPermissions } from '@engineering11/payment-web'

export enum Permission {
  SellItems = 'seller/sell-items',
  ManageSellerApplications = 'seller/manage-seller-applications',
  ManageCompanySettings = 'company/manage-company-settings',
}

export type AllPermissions = Permission | CustomerPermissions | PaymentPermissions
